import { SettingsService } from './servicios/settings.service';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OneSignalPlugin, UserChangedState } from 'onesignal-cordova-plugin';
// import OneSignal, { UserChangedState } from 'onesignal-cordova-plugin';

import OneSignal from 'onesignal-cordova-plugin';
import { VersionService } from './servicios/version.service';
import { EnvironmentInjector } from '@angular/core';
import { setupAxiosSecurity } from './interceptors/axios-security';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(private settings: SettingsService,
    private versionService: VersionService,
    public environmentInjector: EnvironmentInjector
  ) {
    setupAxiosSecurity();
    switch (environment.club){
      case 'alpha':
        settings.enableAlpha();
        break;
      case 'sports':
        settings.enableSportsPlaza();
        break;
      case 'cimera':
        settings.enableCimera();
        break;
      case 'cenit':
        settings.enableCenit();
        break;
      case 'cimeragym':
        settings.enableCimeraGym();
        break;
    };


  //   // Remove this method to stop OneSignal Debugging
  //   OneSignal.Debug.setLogLevel(6);
  //   // Replace YOUR_ONESIGNAL_APP_ID with your OneSignal App ID
  //   OneSignal.initialize(environment.appid);
  //   OneSignal.Notifications.addEventListener('click', async (e) => {
  //     const clickData = await e.notification;
  //     console.log('Notification Clicked : ' + clickData);
  //   });
  //   OneSignal.Notifications.requestPermission(true).then((success: boolean) => {
  //     console.log('Notification permission granted ' + success);
  //     environment.notification = success;
  //   });
  //   const listener = (event: UserChangedState) => {
  //     console.log('User changed: ' + (event));
  //   };

   // Enable verbose logging for debugging (remove in production)
      // OneSignal.Debug.setLogLevel(6);
      // // Initialize with your OneSignal App ID
      // OneSignal.initialize(environment.appidsports);
      // // Use this method to prompt for push notifications.
      // // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
      // OneSignal.Notifications.requestPermission(false).then((accepted: boolean) => {
      //   console.log("User accepted notifications: " + accepted);
      // });

  }
}
